import React, { useEffect } from 'react';

import { Typography } from 'antd';

import leadsService from 'v2/services/leads/list';

import Details from './Details';
import Filter from './Filter';
import List from './List';

const Leads = () => {
  useEffect(() => {
    return () => leadsService.cleanFilter();
  }, []);

  return (
    <>
      <div id='my-leads' className='flex items-start justify-between'>
        <div className='mb-4 w-full flex-1'>
          <Typography.Title level={2}>Meus Leads</Typography.Title>
          <Typography.Text type='secondary'>
            Acompanhe a evolução de sua lista de Leads (e-mails) trazidos por você como produtor ou por seus afiliados.
          </Typography.Text>
        </div>
      </div>

      <Filter />
      <Details />
      <List />
    </>
  );
};

export default Leads;
